module.exports = __webpack_public_path__ + "static/media/error-alert.40327a05.png";